// extracted by mini-css-extract-plugin
export default {"button":"UserButton_button__5NNu7"};